import { render, staticRenderFns } from "./LeaguePageNav.vue?vue&type=template&id=a3a68f36&scoped=true&"
import script from "./LeaguePageNav.vue?vue&type=script&lang=js&"
export * from "./LeaguePageNav.vue?vue&type=script&lang=js&"
import style0 from "./LeaguePageNav.vue?vue&type=style&index=0&id=a3a68f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a68f36",
  null
  
)

export default component.exports